import SRS from '../../../services/StudentRecordService';
import { getUserData } from 'Services/API';

export async function fetchReport(classId, student, selectedPercentiles, locale) {
  let studentId = null
  if (student) studentId = student.value

  const useARM = selectedPercentiles && selectedPercentiles.state !== "US";
  const {useLatestARM} = getUserData();
  const data = await SRS.getReadingRopeData({ classId, studentId, useARM, locale, useLatestARM });
  return data.readingRopeReport;
}